import { Text } from 'react-native';
import { CustomRendererProps, TBlock } from 'react-native-render-html';

import { extractText, useHTMLLinkStyle } from 'app/components/HTML/LinkRenderer/LinkRenderer.utils';
import { useMessaging } from 'app/providers/MessagingProvider';

export default function OpenChat({ tnode }: CustomRendererProps<TBlock>) {
  const { open } = useMessaging();
  const linkStyle = useHTMLLinkStyle();

  return (
    <Text accessibilityRole="link" accessible style={linkStyle} onPress={open}>
      {extractText(tnode.domNode)}
    </Text>
  );
}
